import constants from '@/utils/constants'

export default {
  install(Vue, options) {
    Vue.prototype.$constants = constants
    Vue.prototype.$lazyLoad = function(runFunc = () => {}, timeout = 1000) {
      return setTimeout(() => {
        try {
          runFunc()
        } catch (e) {
          console.error(e)
        }
      }, timeout)
    }
    Vue.prototype.$simpleClone = function(target, ...source) {
      if (source.length > 0) {
        source.forEach(sr => {
          Object.assign(target, sr)
        })
      }
      return target
    }
    Vue.prototype.$deepClone = function(source) {
      return JSON.parse(JSON.stringify(source))
    }
    Vue.prototype.$hasPermission = function(perms) {
      if (perms) {
        const permissions = this.$store.state.account.permissions
        if (Array.isArray(perms)) {
          let flag = false
          // eslint-disable-next-line no-unused-vars
          for (const v of perms) {
            if (permissions.includes(v.toLowerCase())) {
              flag = true
              break
            }
          }
          return flag
        } else {
          return permissions.includes(perms.toLowerCase())
        }
      } else {
        return true
      }
    }
    Vue.prototype.$hasRole = function(roles) {
      if (roles) {
        const permissions = this.$store.state.account.user['roleCodes']
        if (permissions === null || permissions.length === 0) {
          return false
        }
        if (Array.isArray(roles)) {
          let flag = false
          // eslint-disable-next-line no-unused-vars
          for (const v of roles) {
            if (permissions.includes(v.toLowerCase())) {
              flag = true
              break
            }
          }
          return flag
        } else {
          return permissions.includes(roles.toLowerCase())
        }
      } else {
        return true
      }
    }
    Vue.prototype.$resetForm = function(refForm, onlyClearValidate = false) {
      return new Promise((resolve, reject) => {
        this.$nextTick(() => {
          const _form = this.$refs[refForm]
          if (_form) {
            if (onlyClearValidate === true) {
              _form.clearValidate()
            } else {
              _form.resetFields()
            }
            resolve(_form)
          } else {
            reject('form[' + refForm + ']不存在')
          }
        })
      })
    }
    Vue.prototype.$clearValidate = function(refForm, fieldNames, beforeFunction) {
      return new Promise((resolve, reject) => {
        if (fieldNames) {
          if (beforeFunction && beforeFunction instanceof Function) {
            beforeFunction()
          }
          this.$nextTick(() => {
            const _form = this.$refs[refForm]
            if (_form) {
              _form.clearValidate(fieldNames)
              resolve(_form)
            } else {
              reject('form[' + refForm + ']不存在')
            }
          })
        } else {
          reject('fieldNames不能为空')
        }
      })
    }

    Vue.prototype.$objectIsType = function(value, type = 'string') {
      // 转换为小写
      const _type = type.toLowerCase()
      if ('object string array number boolean null date undefined function map set'.indexOf(_type) < 0) {
        throw new Error('type类型不存在：' + _type)
      }
      // 当值为空时，如果判断的类型不是Null和Undefined时，返回false
      if (value === null) {
        return _type === 'null'
      }
      if (value === undefined) {
        return _type === 'undefined'
      }
      const valueType = Object.prototype.toString.call(value).toLowerCase()
      return (valueType === '[object ' + _type + ']')
    }
    Vue.prototype.$checkIsEmpty = function(value) {
      if (value === null || value === undefined) {
        return true
      } else if (this.$objectIsType(value, 'String')) {
        if (value.length === 0 || value.trim().length === 0) {
          return true
        }
      } else if (this.$objectIsType(value, 'Array')) {
        if (value.length === 0) {
          return true
        }
      } else if (this.$objectIsType(value, 'Object')) {
        if (Object.keys(value).length === 0) {
          return true
        }
      }
      return false
    }
    /**
     * @param oldData 比较对象1
     * @param newData 比较对象2
     * @param objCompareKey 比较的属性name
     * @returns {boolean}
     */
    Vue.prototype.$objectCompare = function(oldData, newData, objCompareKey) {
      const _this = this
      // 类型为基本类型时,如果相同,则返回true
      if (oldData === newData) {
        return true
      } else if (
        _this.$objectIsType(oldData, 'object') &&
        _this.$objectIsType(newData, 'object')
      ) {
        // eslint-disable-next-line no-prototype-builtins
        if (_this.$objectIsType(objCompareKey, 'string') && oldData.hasOwnProperty(objCompareKey) && newData.hasOwnProperty(objCompareKey)) {
          if (!_this.$objectCompare(oldData[objCompareKey], newData[objCompareKey])) {
            // 对象中具有不相同属性 返回false
            return false
          }
        } else if (Object.keys(oldData).length === Object.keys(newData).length) {
          // 遍历所有对象中所有属性,判断元素是否相同
          // eslint-disable-next-line no-unused-vars
          for (const key in oldData) {
            // eslint-disable-next-line no-prototype-builtins
            if (oldData.hasOwnProperty(key)) {
              if (!_this.$objectCompare(oldData[key], newData[key])) {
                return false
              }
            }
          }
        } else {
          return false
        }
      } else if (
        _this.$objectIsType(oldData, 'array') &&
        _this.$objectIsType(newData, 'array') &&
        oldData.length === newData.length
      ) {
        // 附加代码 对数组统一排序
        oldData = oldData.sort()
        newData = newData.sort()
        // 类型为数组并且数组长度相同
        for (let i = 0, length = oldData.length; i < length; i++) {
          if (!_this.$objectCompare(oldData[i], newData[i])) {
            // 如果数组元素中具有不相同元素,返回false
            return false
          }
        }
      } else {
        // 其它类型,均返回false
        return false
      }
      return true
    }
    /**
     * this.$objectRemove(this.emitFileList, { 'fileId': fileId }, 'fileId')
     * @param obj 数组或对象
     * @param removeAttr 需要删除的数据，数组或对象
     * @param objCompareKey 根据什么key去删除
     */
    Vue.prototype.$objectRemove = function(obj, removeAttr, objCompareKey) {
      const _this = this
      if (obj && removeAttr) {
        if (_this.$objectIsType(removeAttr, 'array')) {
          removeAttr.forEach((item) => {
            _this.$objectRemove(obj, item, objCompareKey)
          })
        } else {
          if (_this.$objectIsType(obj, 'array') && obj.length > 0) {
            // 循环去删除数组的item
            for (let i = 0; i < obj.length;) {
              if ((typeof obj[i]) !== (typeof removeAttr)) {
                throw new Error('objectRemove方法，类型不一致：数组属性类型[' + (typeof obj[i]) + '],删除参数类型[' + (typeof removeAttr) + ']')
              }
              // 比较成功后就删除
              if (_this.$objectCompare(obj[i], removeAttr, objCompareKey)) {
                obj.splice(i, 1)
              } else {
                i++
              }
            }
          } else if (_this.$objectIsType(obj, 'object') && Object.keys(obj).length > 0) {
            if (_this.$objectIsType(removeAttr, 'string')) {
              if (obj[removeAttr]) {
                Reflect.deleteProperty(obj, removeAttr)
              }
            } else if (_this.$objectIsType(removeAttr, 'object')) {
              if (obj[objCompareKey] === removeAttr[objCompareKey]) {
                Reflect.deleteProperty(obj, objCompareKey)
              }
            } else {
              throw new Error('objectRemove方法，删除的参数类型只能为String,当前参数类型:' + (typeof removeAttr))
            }
          }
        }
      }
      return obj
    }
    /**
     *
     * @param obj
     * @param findAttr 当findAttr是string时，keyOrValue就是value，当findAttr是对象时，keyOrValue就是key
     * @param keyOrValue
     * @returns {null|*}
     */
    Vue.prototype.$findByArray = function(obj, findAttr, keyOrValue) {
      const _this = this
      if (obj && findAttr) {
        if (_this.$objectIsType(findAttr, 'string')) {
          // 遍历查找对象
          for (let i = 0; i < obj.length; i++) {
            // 比较成功后就返回
            if (obj[i][findAttr] === keyOrValue) {
              return obj[i]
            }
          }
        } else if (_this.$objectIsType(findAttr, 'object') && Object.keys(findAttr).length > 0) {
          // 遍历查找对象
          for (let i = 0; i < obj.length;) {
            if ((typeof obj[i]) !== (typeof findAttr)) {
              throw new Error('objectRemove方法，类型不一致：数组属性类型[' + (typeof obj[i]) + '],查找参数类型[' + (typeof findAttr) + ']')
            }
            // 比较成功后就返回
            if (_this.$objectCompare(obj[i], findAttr, keyOrValue)) {
              return obj[i]
            } else {
              i++
            }
          }
        }
        return null
      }
    }
    Vue.prototype.$deepRemove = function(obj, deepNodeName, removeAttr, objCompareKey) {
      const _this = this
      if (obj) {
        if (_this.$objectIsType(obj, 'array')) {
          const deletedArrays = _this.$objectRemove(obj, removeAttr, objCompareKey)
          if (deletedArrays && deletedArrays.length > 0) {
            deletedArrays.forEach((item) => {
              _this.$deepRemove(item, deepNodeName, removeAttr, objCompareKey)
            })
          }
        } else if (_this.$objectIsType(obj, 'object')) {
          _this.$objectRemove(obj, removeAttr, objCompareKey)
          if (obj[deepNodeName]) {
            _this.$deepRemove(obj[deepNodeName], deepNodeName, removeAttr, objCompareKey)
          }
        }
      }
    }
    Vue.prototype.$deepFind = function(obj, deepNodeName, findAttr, result = []) {
      const _this = this
      if (obj) {
        if (_this.$objectIsType(obj, 'array')) {
          if (obj.length > 0) {
            obj.forEach((item) => {
              _this.$deepFind(item, deepNodeName, findAttr, result)
            })
          }
        } else if (_this.$objectIsType(obj, 'object')) {
          result.push(obj[findAttr])
          if (obj[deepNodeName]) {
            _this.$deepFind(obj[deepNodeName], deepNodeName, findAttr, result)
          }
        }
      }
      return result
    }
    Vue.prototype.$registerSocket = function(type, callback) {
      this.$nextTick(() => {
        this.$store.dispatch('sockets/addView', { 'type': type, 'method': callback })
      })
    }
    Vue.prototype.$destorySocket = function(type) {
      this.$store.dispatch('sockets/deleteView', type)
    }
    Vue.prototype.$isValidIp = function(ip) {
      if (ip) {
        // 判断地址是否有效
        const IPV4 = /^((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$/
        // 输出  校验通过：true   校验出错：false
        return IPV4.test(ip)
      }
      return false
    }

    Vue.prototype.$isVideo = function(type) {
      if (type) {
        const videoRegex = /(\mp4|\avi|\mkv)$/i
        return videoRegex.test(type)
      }
      return false
    }

    // Vue.prototype.$doubleEqual = function(left, right) {
    //   return Math.abs(left - right) < Number.EPSILON * Math.pow(2, 2)
    // }
  }
}
